import { NgModule } from '@angular/core';

import { SnapshotDirective } from './snapshot.directive';

@NgModule({
   declarations: [SnapshotDirective],
   exports: [SnapshotDirective]
})
export class SnapshotModule { }
